<template>
	<v-alert
		v-if="visible"
		data-testid="ownership-banner"
		type="info"
		variant="tonal"
		density="compact"
		icon="mdi-key-change"
		class="mb-4"
	>
		<div class="d-flex align-center flex-wrap ga-2">
			<span class="flex-grow-1">{{ $t("ownershipTransfer.banner") }}</span>
			<v-btn size="small" variant="text" to="/ownership-transfer">
				{{ $t("ownershipTransfer.viewRequest") }}
			</v-btn>
		</div>
	</v-alert>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import ownershipTransferService from "@/services/ownershipTransferService";

// Avisa o destinatário de uma transferência de propriedade em qualquer tela —
// o e-mail pode não chegar, e quem recebe pode ser membro sem acesso à tela
// de Usuários.
const route = useRoute();
const received = ref(false);

const visible = computed(() => received.value && route.path !== "/ownership-transfer");

// Quem não tem pedido reconsulta no máximo uma vez por minuto, ao trocar de
// tela: o pedido pode chegar com o sistema já aberto, e o layout não remonta.
const RECHECK_MS = 60_000;
let lastCheck = 0;

async function load() {
	lastCheck = Date.now();
	try {
		const pending = await ownershipTransferService.getPending();
		received.value = pending?.direction === "RECEIVED";
	} catch {
		received.value = false;
	}
}

onMounted(load);

// Com aviso aberto, reconsulta a cada navegação (some logo depois da resposta).
watch(
	() => route.path,
	() => {
		if (received.value || Date.now() - lastCheck >= RECHECK_MS) load();
	},
);
</script>
